import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useBrandZone } from '../../hooks/useBrandZone'
import { State } from '../../types/state'
import Loader from '../Common/Loader'
import Pagination from '../Common/Pagination'
import BrandCard from './components/BrandCard'
import EmptyState from '../Common/EmptyState'
import { PageBanner } from '../Banners/PageBanner'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
const BrandZone: React.FC = () => {
  const navigate = useNavigate()
  const { isSuperadmin } = useSelector((state: State) => state.user)

  const {
    brands,
    loading,
    searchQuery,
    currentPage,
    totalPages,
    totalCount,
    itemsPerPage,
    handleSearch,
    handlePageChange,
    handleItemsPerPageChange
  } = useBrandZone()

  // Przekierowanie do szczegółów marki
  const handleBrandClick = (id: number) => {
    navigate(`/brands/${id}`)
  }

  const handleAddBrand = () => {
    navigate('/brands/add')
  }

  return (
    <>
      <Header />
      <PageBanner title='Marki' description='Przeglądaj marki dostępne w naszej bazie' />
      <section className='brands-section pt-60 pb-60'>
        <div className='container' style={{ marginTop: '6vh' }}>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='brands-filter-bar mb-40 d-flex align-items-center justify-content-between flex-wrap'>
                <div className='search-box mb-3 mb-md-0'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Szukaj marki...'
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>
                {isSuperadmin && (
                  <div className='action-buttons'>
                    <button
                      className={`
                                      tw-mr-2 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                      tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                                    `}
                      onClick={handleAddBrand}
                    >
                      <i className='fas fa-plus mr-2' /> Dodaj markę
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-12'>
              {loading
                ? (
                  <Loader />
                  )
                : (
                  <div className='row'>
                    {brands.length > 0
                      ? (
                          brands.map(brand => (
                            <div key={brand.id} className='col-sm-6 col-md-4 col-lg-3 mb-30'>
                              <BrandCard
                                brand={brand}
                                onBrandClick={handleBrandClick}
                              />
                            </div>
                          ))
                        )
                      : (
                        <EmptyState
                          title='Nie znaleziono marek spełniających wybrane kryteria'
                          description='Spróbuj zmienić parametry wyszukiwania lub wyczyścić filtry.'
                        />
                        )}
                  </div>
                  )}

              {brands.length > 0 && (
                <div className='pagination-section mt-50 mb-30'>
                  <div className='row align-items-center'>
                    <div className='col-12'>
                      <div className='pagination-info-wrapper text-center mb-4'>
                        <div className='pagination-current-page'>
                          <span className='badge badge-pill badge-primary px-4 py-2 current-page-large'>
                            <span className='page-indicator'>Strona</span> <strong className='page-number'>{currentPage}</strong> <span className='page-indicator'>z</span> <strong className='page-number'>{totalPages}</strong>
                          </span>
                        </div>
                        <div className='pagination-total-info mt-2'>
                          Wyświetlanie <strong>{(currentPage - 1) * itemsPerPage + 1}</strong> - <strong>{Math.min(currentPage * itemsPerPage, totalCount)}</strong> z <strong>{totalCount}</strong> marek
                        </div>
                      </div>

                      {totalPages > 1 && (
                        <Pagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={handlePageChange}
                        />
                      )}

                      <div className='items-per-page-selector-wrapper text-center mt-4'>
                        <div className='items-per-page-selector d-inline-block'>
                          <label className='mr-2'>Marek na stronie:</label>
                          <select
                            className='form-control form-control-sm d-inline-block w-auto'
                            value={itemsPerPage}
                            onChange={(e) => handleItemsPerPageChange(parseInt(e.target.value, 10))}
                          >
                            <option value='12'>12</option>
                            <option value='24'>24</option>
                            <option value='48'>48</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default BrandZone
